module.exports = __webpack_public_path__ + "media/Mi Casa es tu Casa.2ebf2516.mp3";